import api from "./apiClient"

export default{
    getLast100AlarmSignals: async () => await api.get('LastAlarmSignals')
}